import { render, staticRenderFns } from "./form-add-new-product.vue?vue&type=template&id=3dedd879&"
import script from "./form-add-new-product.vue?vue&type=script&lang=js&"
export * from "./form-add-new-product.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports